module.exports = __webpack_public_path__ + "static/img/wbHoverTop.95c132b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/footer/wbHoverTop.png
// module id = a4/F
// module chunks = 12